<div class="modal-content">
  <apm-section-title title="{{ '445220' | apmTranslate }}" icon="t_search"></apm-section-title>
  <div class="d-flex classes-height">
    <ng-container *ngIf="groupedClasses$ | async as groupedClasses">
      <div class="w-100 me-3" *ngFor="let group of groupedClasses | keyvalue; last as isLast">
        <apm-list-tile class="mb-2" *ngFor="let c of group.value" (listTileClick)="filterSelected(c)">
          {{ c.description ? c.description : (c.descriptionId | apmTranslate) }}
        </apm-list-tile>
        <ng-container *ngIf="custom && isLast">
          <apm-list-tile class="mb-2" (listTileClick)="customSelected()">
            {{ '445221' | apmTranslate }}
          </apm-list-tile>
          <apm-list-tile class="mb-2" (listTileClick)="utaSelected()">
            {{ '445222' | apmTranslate }}
          </apm-list-tile>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
